import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './picker.less'
import { getNow, momentum, DEFAULT_OPTIONS, getComputedPosition, bezierMap } from './utils'

class Picker extends Component {
    static propTypes = {
        height: PropTypes.number,
        itemHeight: PropTypes.number,
        indicatorTop: PropTypes.number,
        indicatorHeight: PropTypes.number,
        onChange: PropTypes.func,
        aniamtion: PropTypes.bool,
        groupIndex: PropTypes.number,
        defaultIndex: PropTypes.number
    }

    static defaultProps = {
        height: 252,
        itemHeight: 36, // content + padding
        indicatorTop: 108,
        indicatorHeight: 36,
        aniamtion: true,
        groupIndex: -1,
        defaultIndex: -1,
        mapKeys: {
            label: 'label'
        }
    }

    constructor(props) {
        super(props)

        this.state = {
            totalHeight: 0,
            selected: 0,
            animating: this.props.animation
        }

        this.gestureData = {
            touching: false, // 当前是否是touch操作状态
            ogY: 0,
            ogTranslate: 0,
            touchId: undefined,
            translate: 0,
            totalHeight: 0
        }
    }

    componentDidMount() {
        this.adjustPosition(this.props)
        this.userSelect = document.body.style.userSelect
        document.body.style.userSelect = 'none'
    }

    componentWillUnmount() {
        document.body.style.userSelect = this.userSelect
    }

    componentWillReceiveProps(nextProps) {
        this.adjustPosition(nextProps)
    }

    adjustPosition(props) {
        const { items, itemHeight, indicatorTop, defaultIndex } = props
        const totalHeight = items.length * itemHeight
        let translate = totalHeight <= indicatorTop ? indicatorTop : 0

        if (defaultIndex > -1) {
            if (translate === 0) {
                const upperCount = Math.floor(indicatorTop / itemHeight)
                if (defaultIndex > upperCount) {
                    // over
                    const overCount = defaultIndex - upperCount
                    translate -= overCount * itemHeight
                } else if (defaultIndex === upperCount) {
                    translate = 0
                } else {
                    // less
                    translate += (Math.abs(upperCount - defaultIndex) * itemHeight)
                }
                // if(props.groupIndex == 2) console.log(defaultIndex,translate, upperCount)
            } else {
                // total item less than indicator height
                translate -= itemHeight * defaultIndex
            }
        }

        this.gestureData = Object.assign({},
            this.gestureData,
            {
                ogTranslate: translate, translate: translate, bezier: bezierMap.noBounce
            })

        const layoutStyleTransform = `translate3d(0px, ${this.gestureData.translate}px, 0px)`
        // panel.current.style.transition = 'all 0.1s ease-in-out'
        this.picker.style.cssText = `transition:transform 0ms ${this.gestureData.bezier};transform:${layoutStyleTransform};`

        this.setState({
            selected: defaultIndex, totalHeight
        }, () => defaultIndex > -1 ? this.updateSelected(false) : this.updateSelected())
    }

    updateSelected = (propagate = true) => {
        const { items, itemHeight, indicatorTop, indicatorHeight, onChange, groupIndex } = this.props
        let selected = 0
        items.forEach((item, i) => {
            if (!item.disabled && (this.gestureData.translate + (itemHeight * i)) >= indicatorTop &&
                (this.gestureData.translate + (itemHeight * i) + itemHeight) <= indicatorTop + indicatorHeight) {
                selected = i
            }
        })

        if (onChange && propagate) onChange(items[selected], selected, groupIndex)
    }

    onStart = (y, id) => {
        if (this.gestureData.touching || this.props.items.length <= 1) return
        this.startTime = getNow()
        this.momentumStartY = 0
        this.stop()

        this.gestureData = Object.assign({}, this.gestureData, {
            touching: true,
            ogTranslate: this.gestureData.translate,
            touchId: id,
            ogY: this.gestureData.translate === 0 ? y : y - this.gestureData.translate,
            animating: false
        })
    }

    onMove = (y, id) => {
        if (!this.gestureData.touching || this.props.items.length <= 1) return
        if (id !== this.gestureData.touchId) return
        const { indicatorTop, indicatorHeight } = this.props

        const pageY = y
        // 浮点数坐标会影响渲染速度
        let diffY = Math.round(pageY - this.gestureData.ogY)

        // 超出边界时增加阻力
        const lowerMargin = indicatorTop + indicatorHeight - this.state.totalHeight
        const upperMargin = indicatorTop
        if ((diffY > upperMargin) || (diffY < lowerMargin)) {
            if (diffY > upperMargin) {
                diffY = (diffY - upperMargin) / 3 + upperMargin
            }
            if (diffY < lowerMargin) {
                diffY = -(lowerMargin - diffY) / 3 + lowerMargin
            }
        }

        const now = getNow()
        // 记录在触发惯性滑动条件下的偏移值和时间
        if (now - this.startTime > DEFAULT_OPTIONS.momentumLimitTime) {
            this.startTime = now
            this.momentumStartY = diffY
        }

        this.gestureData = Object.assign({}, this.gestureData, {
            translate: diffY,
            bezier: bezierMap.noBounce
        })

        const layoutStyleTransform = `translate3d(0px, ${this.gestureData.translate}px, 0px)`
        this.picker.style.cssText = `transition:transform 0ms ${this.gestureData.bezier};transform:${layoutStyleTransform};`
    }

    onFinish = () => {
        if (!this.gestureData.touching || this.props.items.length <= 1) return

        const { indicatorTop, indicatorHeight, itemHeight } = this.props
        let translate = this.gestureData.translate
        let momentumY
        let bounceDuration = 500
        let bezier = 'cubic-bezier(.165, .84, .44, 1)'

        if (Math.abs(translate - this.gestureData.ogTranslate) < (itemHeight * 0.51)) {
            // translate = this.gestureData.ogTranslate
            translate = this.adjustStopPosition(translate)
            // translate = this.needAdjustPosition(translate, this.gestureData.ogTranslate, itemHeight)
        } else if (translate > indicatorTop) {
            // top boundry
            translate = indicatorTop
        } else if (translate + this.state.totalHeight < indicatorTop + indicatorHeight) {
            // bottom
            translate = indicatorTop + indicatorHeight - this.state.totalHeight
        } else {
            // pass single item range but not exceed boundry
            this.endTime = getNow()

            const absDistY = Math.abs(translate - this.momentumStartY)
            const duration = this.endTime - this.startTime
            const wrapperSize = this.props.height
            if (duration < DEFAULT_OPTIONS.momentumLimitTime && absDistY > DEFAULT_OPTIONS.momentumLimitDistance) {
                const lowerMargin = indicatorTop + indicatorHeight - this.state.totalHeight
                const upperMargin = indicatorTop
                momentumY = momentum(translate, this.gestureData.ogTranslate, duration, lowerMargin, upperMargin, wrapperSize)
                translate = momentumY.destination
                bounceDuration = momentumY.duration
                bezier = momentumY.bezier
                if (translate <= upperMargin && translate >= lowerMargin) {
                    translate = this.adjustStopPosition(translate)
                }
            } else {
                translate = this.adjustStopPosition(translate)
            }
        }

        this.gestureData = Object.assign({}, this.gestureData, {
            touching: false,
            ogY: 0,
            touchId: undefined,
            ogTranslate: 0,
            animating: true,
            duration: bounceDuration,
            bezier: bezier,
            translate
        })

        const layoutStyleTransform = `translate3d(0px, ${this.gestureData.translate}px, 0px)`
        this.picker.style.cssText = `transition:transform ${this.gestureData.duration}ms ${this.gestureData.bezier} ;transform:${layoutStyleTransform};`
    }

    onTransitionEnd() {
        let translate = this.gestureData.translate
        const animating = true
        const { indicatorTop, indicatorHeight } = this.props
        const lowerMargin = indicatorTop + indicatorHeight - this.state.totalHeight
        const upperMargin = indicatorTop
        const bounceDuration = 500
        const bezier = 'cubic-bezier(.165, .84, .44, 1)'
        if (translate > upperMargin) {
            // top boundry
            translate = upperMargin
            this.gestureData = Object.assign({}, this.gestureData, {
                animating: animating,
                duration: bounceDuration,
                bezier: bezier,
                translate
            })

            const layoutStyleTransform = `translate3d(0px, ${this.gestureData.translate}px, 0px)`
            this.picker.style.cssText = `transition:transform ${this.gestureData.duration}ms ${this.gestureData.bezier} ;transform:${layoutStyleTransform};`
        } else if (translate < lowerMargin) {
            // bottom
            translate = lowerMargin
            this.gestureData = Object.assign({}, this.gestureData, {
                animating: animating,
                duration: bounceDuration,
                bezier: bezier,
                translate
            })

            const layoutStyleTransform = `translate3d(0px, ${this.gestureData.translate}px, 0px)`
            this.picker.style.cssText = `transition:transform ${this.gestureData.duration}ms ${this.gestureData.bezier} ;transform:${layoutStyleTransform};`
        } else {
            this.updateSelected()
        }
    }

    stop() {
        const { y } = getComputedPosition(this.picker)
        const translate = y

        this.gestureData = Object.assign({}, this.gestureData, {
            animating: false,
            bezier: bezierMap.noBounce,
            translate
        })
        const layoutStyleTransform = `translate3d(0px, ${this.gestureData.translate}px, 0px)`
        this.picker.style.cssText = `transition:transform 0ms ${this.gestureData.bezier};transform:${layoutStyleTransform};`
    }

    // 调整位置
    needAdjustPosition(ctTranslate, _ogTranslate, _itemHeight, scrollTrend) {
        let translate = ctTranslate
        const itemHeight = _itemHeight
        const ogTranslate = _ogTranslate
        let step = 0; let adjust = 0
        const diff = (translate - ogTranslate) / itemHeight

        if (Math.abs(diff) < 1) {
            step = diff > 0 ? 1 : -1
        } else {
            adjust = Math.abs((diff % 1) * 100) > 50 ? 1 : 0
            step = diff > 0 ? Math.floor(diff) + adjust : Math.ceil(diff) - adjust
        }

        translate = ogTranslate + (step * itemHeight)
        return translate
    }

    // 调整滚动中stop的位置
    adjustStopPosition(ctTranslate) {
        let translate
        let selected = 0
        let adjust
        const { indicatorTop, indicatorHeight, itemHeight } = this.props
        const lowerMargin = indicatorTop + indicatorHeight - this.state.totalHeight
        const upperMargin = indicatorTop
        if (ctTranslate <= lowerMargin) {
            translate = lowerMargin
        } else if (ctTranslate >= upperMargin) {
            translate = upperMargin
        } else {
            this.props.items.forEach((item, index) => {
                if (((indicatorTop - index * itemHeight) >= ctTranslate) && ((indicatorTop - (index + 1) * itemHeight) <= ctTranslate)) {
                    selected = index
                }
            })
            adjust = Math.abs(indicatorTop - selected * itemHeight - ctTranslate) / itemHeight
            if (adjust > 0.51) {
                selected = selected + 1
            }

            translate = indicatorTop - selected * itemHeight
        }
        this.gestureData = Object.assign({}, this.gestureData, {
            translate
        })
        return translate
    }

    render() {
        const touchEvent = {
            onTouchStart: e => this.onStart(e.targetTouches[0].screenY, e.targetTouches[0].identifier),
            onTouchMove: e => {
                e.preventDefault()
                this.onMove(e.touches[0].screenY, e.targetTouches[0].identifier)
            },
            onTouchEnd: () => this.onFinish(),
            onMouseDown: e => this.onStart(e.screenY),
            onMouseMove: e => {
                e.preventDefault()
                this.onMove(e.screenY)
            },
            onMouseUp: () => this.onFinish(),
            onTransitionEnd: (e) => this.onTransitionEnd(e)
        }

        // const pickerStyle = {
        //   transform: `translate3d(0, ${this.state.translate}px, 0)`,
        //   transition: this.state.animating ? `transform ${this.state.duration}ms ${this.state.bezier}` : 'none'
        // }

        const { style, className, items } = this.props

        const cls = classNames(styles.picker, className)

        return (
            <div className={cls} style={style} {...touchEvent}>
                <div className={styles['picker-mask']} />
                <div className={styles['picker-indicator']} />
                <div className={styles['picker-content']} ref={(ref) => (this.picker = ref)}>
                    {
                        items.map((item, j) => {
                            const label = item[this.props.mapKeys.label]
                            return <div key={j} className={styles['picker-item']}>{label}</div>
                        })
                    }
                </div>
            </div>
        )
    }
}

export default Picker
